import React, { Component } from 'react';
import { Header, Icon, Button, Modal } from 'semantic-ui-react'
import axios from 'axios'
import { base, serverIp, PAYMENT_TYPE_NO_NEED_TO_PAY, PAYMENT_TYPE_PRINTING_CHARGE} from '../../../../config/constants';

class GetRecentUnPaidStockPaymentsCell extends Component {
    constructor(props) {
        super(props);
        this.state = {
            added: false
        }
    }

    componentDidMount(){
        console.log("gstx30 ++++++++: componentDidMount");
        console.log("gstx31 +++++++:GetRecentUnPaidStockPaymentsCell");
        console.log("gstx33 printingChargePaid:"+this.props.unpaidItem.shirtType);
    
    }

    internalAddItem = () =>{
        console.log("gstx34 ++++++++: internalAddItem");
        this.props.addItem(this.props.unpaidItem);

        if(this.state.added === false){
            console.log("this.state.added === false");
            this.setState({
                added:true
            })
        }else{
            console.log("this.state.added === true");
            this.setState({
                added:false
            })
        }
        
    }

    render() {

        const showCheck = this.state.added 
        ?<div>
            <Icon fitted name='checkmark' />
            
        </div>
        :''
        
        return (
            <div>
                <Button onClick={this.internalAddItem} color='red'>{this.props.title}</Button>
                {showCheck}
                <br/><br/>
            </div>
        )
    }
}

export default GetRecentUnPaidStockPaymentsCell;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/StockPayment/GetRecentUnPaidStockPaymentsCell.js